import React, { useEffect, useState } from 'react';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import { styled } from '@mui/joy/styles';
import Sheet from '@mui/joy/Sheet';
import Grid from '@mui/joy/Grid';
import Button from '@mui/joy/Button';


///////////// Date Formate
import dateFormat, { masks } from "dateformat";


/////////////////////Date Piker
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import Autocomplete from '@mui/joy/Autocomplete';




import ListReports from '../../Components/Reports/ListReports';
import ListMonthlyReports from '../../Components/Reports/ListMonthlyReports';
import FinancialReport from '../../Components/Reports/FinancialReport';
import FinancialCompaniesReport from '../../Components/Reports/FinancialCompaniesReport';
import FinancialBanksReport from '../../Components/Reports/FinancialBanksReport';



const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
    { label: 'The Godfather: Part II', year: 1974 },
    { label: 'The Dark Knight', year: 2008 },
    { label: '12 Angry Men', year: 1957 },
    { label: "Schindler's List", year: 1993 },
    { label: 'Pulp Fiction', year: 1994 },
]

export default function ReportsPage() {
    const [variant, setVariant] = useState('solid');
    const [currentTab, setCurrentTab] = useState(0);

    const [startDateValue, setStartDateValue] = useState(null);
    const [endDateValue, setEndDateValue] = useState(null);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [lessen, setLessen] = useState(0);
    const [ activeNotificationSoomha, setActiveNotificationSoomha ] = useState(null)


    const getCurrentTabs = (event, newValue) => {
        // console.log(newValue)
        // console.log(event)
        setCurrentTab(newValue)
        clearFilter()
    }

    const getStartDate = (data) => {
        setStartDateValue(data)
        let formatDate =  dateFormat(data, "m/d/yyyy")
        setStartDate(formatDate)

    }
    const getEndDate = (data) => {
        setEndDateValue(data)
        let formatDate =  dateFormat(data, "m/d/yyyy")
        setEndDate(formatDate)
    }

    const filterAction = () => {
        if(currentTab != 0) {
            setLessen(lessen + 1)
        }
    }

    const clearFilter = () => {
        setStartDateValue(null) 
        setEndDateValue(null)
        setStartDate(null)
        setEndDate(null)
        filterAction()
    }

    // const checkOrder = () => {
    //    let activeNotificationSoomha = localStorage.getItem('activeNotificationSoomha')
    //    if(activeNotificationSoomha == 'order'){
    //     setCurrentTab(1)
    //    }else{
    //     setCurrentTab(0)
    //    }
    // }

    // useEffect(() => {
    //     checkOrder()
    // })

    return (
        <>
            <Tabs
                variant='plain'
                aria-label="Pricing plan"
                defaultValue={0}
                onChange={getCurrentTabs}
                value={currentTab}
                sx={{
                    width: '100%',
                    borderRadius: 'sm',
                    // boxShadow: 'sm',
                    overflow: 'auto',
                    backgroundColor: '#FBFBFB',
                }}
            >
                <TabList
                    disableUnderline
                    tabFlex={1}
                    size='lg'
                    sx={{
                        width: '80% !important',
                        [`& .${tabClasses.root}`]: {
                            fontSize: 'sm',
                            fontWeight: 'lg',
                            bgcolor: '#FBFBFB',

                            [`&[aria-selected="true"]`]: {
                                color: 'primary.500',
                                bgcolor: '#F7F9FB',
                            },
                            [`&.${tabClasses.focusVisible}`]: {
                                outlineOffset: '-4px',
                            },
                        },
                    }}
                >
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                         التقارير المختصرة
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        التقارير التفصيلية
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        التقارير المالية للافراد
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        التقارير المالية للشركات
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        التقارير المالية للبنوك
                    </Tab>
                </TabList>

                {currentTab != 0 && (

                <Grid container spacing={2} sx={{ flexGrow: 1, padding: '30px 2%', backgroundColor: '#F7F9FB', marginTop:'0' }}>
                    <Grid container xs={8}>
                        <Grid xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker onChange={getStartDate} value={startDateValue} name="start Date" />
                            </LocalizationProvider>
                        </Grid>
                        <Grid xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker onChange={getEndDate} value={endDateValue} name="end Date"/>
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    <Grid xs={3.5} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button size="md" variant={variant} color="primary" onClick={filterAction}>
                            تطبيق التصفية
                        </Button>
                        <Button size="md" variant='outlined' color="primary" onClick={clearFilter}>
                            الغاء التصفية
                        </Button>
                    </Grid>
                </Grid>
                )}

                <TabPanel value={0} sx={{ backgroundColor: '#F7F9FB' }}>
                    <ListReports />
                </TabPanel>
                <TabPanel value={1} sx={{ backgroundColor: '#F7F9FB' }}>
                    <ListMonthlyReports startDate={startDate} endDate={endDate} filterAction={lessen}/>
                </TabPanel>
                <TabPanel value={2} sx={{ backgroundColor: '#F7F9FB' }}>
                    <FinancialReport startDate={startDate} endDate={endDate} filterAction={lessen}/>
                </TabPanel>
                <TabPanel value={3} sx={{ backgroundColor: '#F7F9FB' }}>
                    <FinancialCompaniesReport startDate={startDate} endDate={endDate} filterAction={lessen}/>
                </TabPanel>
                <TabPanel value={4} sx={{ backgroundColor: '#F7F9FB' }}>
                    <FinancialBanksReport startDate={startDate} endDate={endDate} filterAction={lessen}/>
                </TabPanel>
                

                
            </Tabs>
            {/* <Statistics/>
        <StackedAreaChart/> */}
        </>
    )
}